import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { ResultGetModel, ResultModel } from './result.model';

export const onGetResult = (
  gradeId: string,
  sectionId: string,
  examYearId: string,
  examTypeId: string,
): Promise<ResultGetModel[]> => {
  return axiosInstance.get(
    http_config.BASE_URL +
      '/result?gradeId=' +
      gradeId +
      '&sectionId=' +
      sectionId +
      '&examYearId=' +
      examYearId +
      '&examTypeId=' +
      examTypeId,
  );
};

export const onGetResultByStudentId = (studentId: string): Promise<ResultGetModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/result/' + studentId);
};

export const onPostResult = (payload: ResultModel): Promise<ResultModel> => {
  return axiosInstance.post(http_config.BASE_URL + '/result', payload);
};
